export default __webpack_public_path__ + "static/media/106.6ae7a42a.jpg";